import React from 'react';

const Book = props => {
  const { author, year, title, city, state, country, editorial, url } = props;
  return (
    <li>
      <div className="quote">
        <span className="book">
          {
            // autor
            author && author
          }
          {
            // año
            year && ` (${year}). `
          }
          {
            // titulo
            title && <em>{`${title}. `}</em>
          }
          {
            // ciudad
            city && `${city}, `
          }
          {
            // state
            state && `${state}, `
          }
          {
            // pais
            country && `${country}: `
          }
          {
            // editorial
            editorial && `${editorial}.`
          }
        </span>
        {
          // url
          url && (
            <a className="quote-url" href={url}>
              Link
            </a>
          )
        }
      </div>
    </li>
  );
};

export default Book;
